import type { SignupSubRouteRouteContext } from 'router/utils';

import { postOffer } from 'services/partnersSelfSignup/offers';
import {
  type GetLeadResponse,
  getLeadQueryKey,
  readLeadQueryCache,
} from 'services/partnersSelfSignup/signup';

import { hasUserSubmittedPricingStep } from './utils/validation';

type OfferBeforeLoadProps = { context: SignupSubRouteRouteContext };

export async function offerLoader({
  context,
}: OfferBeforeLoadProps): Promise<void> {
  const { queryClient, queryVariables } = context;
  const result = readLeadQueryCache(queryClient, queryVariables);
  const { lead } = result ?? {};

  // Dummy condition that allows preloading the offer if pricing is already available
  if (hasUserSubmittedPricingStep(lead)) {
    if (lead?.offer?.offerId) {
      return;
    }

    const mutation = queryClient.getMutationCache().build(queryClient, {
      mutationFn: postOffer,
    });

    const offer = await mutation.execute({
      leadId: queryVariables.leadId,
      businessEmail: queryVariables.businessEmail,
    });

    const queryKey = getLeadQueryKey(queryVariables);
    queryClient.setQueryData<GetLeadResponse>(queryKey, cacheLead => {
      const currentLead = cacheLead!;

      return {
        ...currentLead,
        lead: {
          ...currentLead?.lead,
          offer,
        },
      };
    });
  }
}
